import {createFeatureSelector, createSelector} from '@ngrx/store';
import {OnboardingState} from './reducer';

export const onboardingState = createFeatureSelector<OnboardingState>('onboarding');

export const showOnboarding = createSelector(onboardingState, (state) => state.isOpen);
